//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {validationMixin} from "vuelidate";
import {between, required} from "vuelidate/lib/validators";
import {mapGetters, mapMutations} from "vuex";
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-user-suggestion.js';
import {annotationValues} from "@/constants";

export default {
  name: "MissionDialog",
  mixins: [validationMixin],

  props: {
    showDialog: {
      type: Boolean,
      value: false,
    },
    editMode: {
      type: Boolean,
      value: false,
    },
    mission: {
      type: Object,
      value: undefined,
    },
    model: {
      type: Object,
      value: undefined,
    },
    setupOutput: String,
    setupCategories: {
      type: Array,
      value: [],
    }
  },

  data: () => ({
    selectedOutput: null,
    selectedCategories: [],
    selectedAssignees: [],
    closeOnClick: true,
    form: {
      scope: null,
      goal: 0,
      priority: null,
    },
    missionSaved: false,
    priorities: [],
    saving: false,
    assigneesMode: 0,
    currentMissionId: null,
    availableReviews: 0
  }),

  watch: {
    mission() {
      this.init();
    },
    setupOutput(value) {
      this.selectedOutput = value;
    },
    setupCategories(value) {
      this.selectedCategories = value;
    },
    setupAssignees(value) {
      this.selectedAssignees = value;
    },

    selectedOutput() {
      this.count();
    },

    selectedCategories() {
      this.count();
    }
  },

  computed: {
    // availableReviews() {
    //   return this.availableReviewsUpdates || this.availableReviews;
    // },
    ...mapGetters(['AIResourcePath', 'projectId']),
    inputs() {
      if (this.model && Object.keys(this.model).length !== 0) {
        const inputs = this.model.properties["ai_model:inputs"];
        return inputs.map((e) => e.name);
      }
      return "";
    },
    outputs() {
      if (this.model && Object.keys(this.model).length !== 0) {
        const outputs = this.model.properties["ai_model:outputs"];
        return outputs.map((e) => e.name);
      }
      return "";
    },
    categories() {
      return this.getCurrentCategories(this.selectedOutput);
    },
  },

  mounted() {
    this.$refs.directory.get().then((results) => {
      this.priorities = results.entries;
    });
  },

  validations: {
    form: {
      scope: {
        required,
      },
      priority: {
        required,
      },
      goal: {
        required,
        between: between(1, 100),
      },
    },
  },

  methods: {
    getCurrentCategories(selectedOutput) {
      if (this.model && Object.keys(this.model).length !== 0) {
        const outputs = this.model.properties["ai_model:outputs"];
        return outputs.filter((output) => (output.name === selectedOutput) || !selectedOutput)
            .map((output) => output.categories).flat();
      }
      return [];
    },
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
    }),
    init() {
      this.form.priority = this.mission.properties["ai_mission:priority"];
      this.form.goal = this.mission.properties["ai_mission:goal"] || 50;
      this.selectedCategories =
          this.mission.properties["ai_mission:categories_focus"];
      this.selectedOutput = this.mission.properties["ai_mission:output_focus"] === 'null' ? null : this.mission.properties["ai_mission:output_focus"];
      this.form.scope = this.mission.properties["dc:title"];
      this.selectedAssignees = this.mission.properties["ai_mission:assignees"] || [];
    },
    isSelected(out) {
      return this.selectedOutput === null || this.selectedOutput === out;
    },
    _nxElementVisible: function (event) {
      event.target.$.s2.$.op.$.nx = this.$refs.coreConnect;
    },
    toggleOutput(e) {
      const value = e.currentTarget.innerText;
      if (this.selectedOutput === value) {
        this.selectedOutput = null;
      } else {
        this.selectedCategories = null;
        this.selectedOutput = value;
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.scope = null;
      this.form.goal = 50;
      this.selectedCategories = null;
      this.selectedOutput = null;
      this.form.priority = null;
      this.selectedAssignees = null;
    },
    closeDialog() {
      this.$emit('cancel');
      this.clearForm();
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.editMode) {
          this.edit();
        } else {
          this.start();
        }
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    start() {
      this.saving = true;
      let path = `/${this.projectId}`;
      if (this.AIResourcePath !== '') {
        path = this.AIResourcePath;
      }

      this.$refs.mission.docPath = `${path}/missions`;
      this.$refs.mission.data = {
        "entity-type": "document",
        type: "AI_Mission",
        name: this.form.scope,
        properties: {
          "dc:title": this.form.scope,
          "ai_mission:goal": parseFloat(this.form.goal),
          "ai_mission:priority": this.form.priority,
          "ai_mission:model": this.model.uid,
          "ai_mission:categories_focus": this.selectedCategories,
          "ai_mission:output_focus": this.selectedOutput,
          "ai_mission:assignees": this.selectedAssignees,
        },
      };
      this.$refs.mission
          .post()
          .then(() => {
            this.displaySuccess(this.$t("model.missions.create.success"));
            this.saving = false;
            this.clearForm();
            this.$emit('callback');
          })
          .catch((error) => {
            this.displayError(error);
            this.saving = false;
          });
    },
    edit() {
      this.saving = true;
      this.$refs.mission.docId = this.mission.uid;
      this.$refs.mission.data = {
        "entity-type": "document",
        type: "AI_Mission",
        properties: {
          "dc:title": this.form.scope,
          "ai_mission:goal": parseFloat(this.form.goal),
          "ai_mission:priority": this.form.priority,
          "ai_mission:model": this.model.uid,
          "ai_mission:categories_focus": this.selectedCategories,
          "ai_mission:output_focus": this.selectedOutput,
          "ai_mission:assignees": this.selectedAssignees,
        },
      };
      this.$refs.mission
          .put()
          .then(() => {
            this.displaySuccess(this.$t("model.missions.edit.success"));
            this.saving = false;
            this.$emit('callback');
          })
          .catch((error) => {
            this.displayError(error);
            this.saving = false;
          });
    },
    suggestionDocTriggered: function (doc) {
      this.selectedAssignees = doc.detail.value.map(item => ({
        username: item.username || item.groupname,
        icon: item.groupname ? 'group' : 'user'
      }));
    },

    // get the available reviews each time the outputs/categories are changed
    count() {
      if (this.selectedCategories && this.outputs) {
        const categoriesLength = this.selectedCategories.length;
        const multiValue = categoriesLength === 0 || categoriesLength > 1;
        const categories = categoriesLength === 0 ? this.categories : this.selectedCategories;
        this.$refs.count.data = {
          outputs: this.getOutputs(multiValue, categories)
        }

        this.$refs.count.post().then(result => {
          this.availableReviews = result.doc_count;
        }).catch((error) => this.displayError(error));
      }
    },
    // build outputs payload to send to the server
    getOutputs(multiValue, categories) {
      let outputs = Object.create(null);
      if (!this.selectedOutput) {
        this.outputs.forEach(output => {
          categories = categories.length === 0 ? this.getCurrentCategories(output) : categories;
          outputs[output] = this.getOutput(multiValue, categories);
        })
      } else {
        categories = categories.length === 0 ? this.getCurrentCategories(this.selectedOutput) : categories;
        outputs[this.selectedOutput] = this.getOutput(multiValue, categories);
      }
      return outputs;
    },
    getOutput(multiValue, categories) {
      return {
        'multiValue': multiValue,
        categories: categories
            .reduce((previousValue, currentValue) => {
              previousValue[currentValue] = {
                type: annotationValues.NOT_SURE
              }
              return previousValue;
            }, Object.create(null))
      }
    },
  },
};
